import _sumBy from 'lodash/sumBy';

/**
* Number of trips (products)
*
* @param {object} payload - items payload
*/
export function numProducts(payload){
    if(payload !== undefined && payload.length > 0){
        const trips = payload.filter(item => item.type === "product");
        return trips.length;
    }
}

/**
* Item products
*
* @param {object} payload - items payload
*/
export function itemProducts(payload){
    if(payload !== undefined && payload.length > 0){
        const trips = payload.filter(item => item.type === "product");
        return trips;
    }else{
        return [];
    }
}


/**
* Check items has any discount 
*
* @param {object} payload - items payload
*/
export function hasDiscounts(payload){
    const discounts = _sumBy(payload, item => item.discount) || 0;
    return discounts > 0 ? true : false
}


/**
* Check items has any paid 
*
* @param {object} payload - items payload
*/
export function hasPaid(payload){
    const paid = _sumBy(payload, item => item.paid) || 0;
    return paid > 0 ? true : false
}

/**
* Check items has any deposit 
*
* @param {object} payload - items payload
*/
export function hasDeposit(payload){
    const deposit = _sumBy(payload, item => item.deposit) || 0;
    return deposit > 0 ? true : false
}

/**
* Check for planner item
*
* @param {object} payload - items payload
*/
export function hasPlannerItem(payload){
    if(payload !== undefined && payload.length > 0){
        return payload.filter(item => (item.type === "planner" || item.type === "builder")).length > 0 ? true : false;
    }
}